const choices = {
    waitForRaising: 'Mon investissement est à long terme, j\'attends qu\'il remonte',
    agreeForLittleLoss: 'Je suis très stressé et j\'accepte une baisse maximum de 5%',
    worryOnBiggestLoss: 'Je commence à m\'inquiéter quand la baisse atteint plus de 20%',
};

export default choices;
